module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Recipe":"Recipe","Restaurant":"Restaurant"},"es":{"Recipe":"Receta","Restaurant":"Restaurante"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./src/i18n/foodItem-types.i18n.json
// module id = 9qcu
// module chunks = 1